import { useState, useEffect } from 'react'

interface Props {
  completeView: boolean
}

export function useAppoimentDialogWrapperData(props: Props) {
  const { completeView } = props
  const [showCompleteModal, setShowCompleteModal] =
    useState<boolean>(completeView)

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null
    if (completeView) {
      if (timer) {
        clearTimeout(timer)
      }
      setShowCompleteModal(completeView)
    } else {
      timer = setTimeout(() => {
        setShowCompleteModal(completeView)
      }, 580)
    }
    return () => {
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [completeView])

  return {
    showCompleteModal,
  }
}
